import React from 'react';
import { ConnectionTokenData } from '../types';

interface ConnectAccountConfirmProps {
  connectionData: ConnectionTokenData;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading: boolean;
  error?: string | null;
}

const ConnectAccountConfirm: React.FC<ConnectAccountConfirmProps> = ({
  connectionData,
  onConfirm,
  onCancel,
  isLoading,
  error
}) => {
  return (
    <div className="flex flex-col min-h-screen bg-zinc-900">
      {/* Header */}
      <div className="px-6 pt-8 pb-6 border-b border-zinc-800/50">
        <button
          onClick={onCancel}
          disabled={isLoading}
          className="flex items-center text-zinc-500 hover:text-zinc-300 transition-colors mb-6 disabled:opacity-50"
        >
          <svg className="w-5 h-5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          <span className="text-sm">Назад</span>
        </button>
        
        <h1 className="text-xl font-semibold text-white">Подключить аккаунт?</h1>
        <p className="text-sm text-zinc-500 mt-1">Подтвердите подключение</p>
      </div>

      {/* Content */}
      <div className="flex-1 px-6 py-6">
        {/* Account info */}
        <div className="p-4 rounded-xl bg-zinc-900 border border-zinc-800 mb-6">
          <div className="flex items-center space-x-3">
            {connectionData.photo ? (
              <img 
                src={connectionData.photo} 
                alt={connectionData.name}
                className="w-12 h-12 rounded-xl object-cover"
              />
            ) : (
              <div className="flex justify-center items-center w-12 h-12 bg-[#27A7E7]/20 rounded-xl">
                <span className="text-lg font-bold text-[#27A7E7]">
                  {connectionData.name.charAt(0).toUpperCase()}
                </span>
              </div>
            )}
            
            <div className="flex-1 min-w-0">
              <div className="font-medium text-white truncate">
                {connectionData.name}
              </div>
              <div className="text-sm text-zinc-500">
                {connectionData.provider === 'telegram' ? 'Telegram' : connectionData.provider}
              </div>
              <div className="text-xs text-zinc-600 font-mono">
                ID: {connectionData.unique}
              </div>
            </div>
          </div>
        </div>

        {/* Error */}
        {error && (
          <div className="p-3 mb-6 rounded-xl bg-red-500/10 border border-red-500/30">
            <div className="flex items-start">
              <svg className="flex-shrink-0 mr-2 w-4 h-4 text-red-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
              <p className="text-sm text-red-400">{error}</p>
            </div>
          </div>
        )}

        {/* Buttons */}
        <div className="space-y-3">
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="w-full flex items-center justify-center px-4 py-3.5 rounded-xl bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 font-medium hover:bg-emerald-500/20 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? (
              <>
                <div className="w-4 h-4 border-2 border-emerald-400 border-t-transparent rounded-full animate-spin mr-2"></div>
                <span>Подключаем...</span>
              </>
            ) : (
              <>
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
                <span>Это мой аккаунт</span>
              </>
            )}
          </button>
          
          <button
            onClick={onCancel}
            disabled={isLoading}
            className="w-full px-4 py-3 rounded-xl bg-zinc-800/50 border border-zinc-700/50 text-zinc-400 font-medium hover:bg-zinc-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Отмена
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConnectAccountConfirm;
